package com.solevo.dist.network.api.orders

import com.solevo.dist.application.models.CartItem
import com.solevo.dist.application.models.Order
import com.solevo.dist.network.infrastructure.utils.DefaultRemoteSourceImplementationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface OrderRemoteSource {
    fun getOrdersLive(): Flow<List<Order>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getOrder(orderId: String): Flow<Order?> = flow { throw DefaultRemoteSourceImplementationException() }
    suspend fun addNewOrder(cartItem: CartItem): Result<Boolean> = Result.failure(DefaultRemoteSourceImplementationException())
}